import getTheme from "@evernowinc/harbard/themes/evernow";
import { useMemo } from "react";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import ehrColors from "../layout/_colors.scss";
import type { AppDispatch, RootState } from "./store";

// Use throughout the app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export const useEhrHarbardTheme = (isDarkMode: boolean = false) => {
  return useMemo(() => {
    return getTheme({
      overrideHtmlFontStyles: false,
      baseSize: 14,
      mobileHtmlFontSize: 14,
      overridePalette: {
        mode: isDarkMode ? "dark" : "light",
        background: {
          default: isDarkMode ? ehrColors.darkBgPrimary : ehrColors.schemeMain,
          paper: isDarkMode ? ehrColors.darkBgPaper : ehrColors.background,
        },
        divider: isDarkMode ? ehrColors.darkDivider : ehrColors.hrBackgroundColor,
        primary: {
          main: isDarkMode ? ehrColors.darkPrimary : ehrColors.primary,
          light: isDarkMode ? ehrColors.darkPrimaryLight : ehrColors.primaryLight,
          dark: isDarkMode ? ehrColors.darkPrimaryDark : ehrColors.primaryDark,
        },
        success: {
          main: isDarkMode ? ehrColors.darkSuccess : ehrColors.success,
        },
        error: {
          main: isDarkMode ? ehrColors.darkDanger : ehrColors.danger,
        },
        warning: {
          main: isDarkMode ? ehrColors.darkWarning : ehrColors.warningDarker,
          light: isDarkMode ? ehrColors.darkWarning : ehrColors.warning,
        },
        text: isDarkMode
          ? {
              primary: ehrColors.darkTextPrimary,
              secondary: ehrColors.darkTextSecondary,
            }
          : undefined,
      },
    });
  }, [isDarkMode]);
};
